import { render, staticRenderFns } from "./TitledList.vue?vue&type=template&id=68908518&scoped=true&"
import script from "./TitledList.vue?vue&type=script&lang=js&"
export * from "./TitledList.vue?vue&type=script&lang=js&"
import style0 from "./TitledList.vue?vue&type=style&index=0&id=68908518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68908518",
  null
  
)

export default component.exports